import { useContext } from 'react';

import { HelpContext, HelpInterface } from './context';

export function useHelp(): HelpInterface {
  return useContext(HelpContext);
}
